import { Box, Button, Flex, FlexProps, Text } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

import { Colors } from 'theme/constants'

import { SUBSCRIPTION_OVERVIEW_CARD_HEIGHT } from './constants'

interface PlanCardProps extends FlexProps {
  title: string
  buttonLabel: string
  paymentDate?: string
  onClick: () => void
  isDisabled?: boolean
}

export const PaymentCard = ({
  title,
  onClick,
  isDisabled,
  paymentDate,
  buttonLabel,
  ...props
}: PlanCardProps) => {
  const { t } = useTranslation('common')

  return (
    <Flex
      flexDirection="column"
      justifyContent="space-between"
      w="full"
      h={`${SUBSCRIPTION_OVERVIEW_CARD_HEIGHT}px`}
      borderRadius="5px"
      border={`1px solid ${Colors.brand.gainsboro}`}
      p="24px"
      {...props}
    >
      <Box>
        <Text fontSize="16px">{title}</Text>

        <Text fontSize="24px" fontWeight={600}>
          {`${
            paymentDate
              ? // @ts-ignore
                t('TRANSLATION_375', {
                  paymentDate,
                })
              : '-'
          }`}
        </Text>
      </Box>

      <Button
        onClick={onClick}
        isDisabled={isDisabled}
        variant="outline"
        w="full"
        h="50px"
        fontSize="17px"
      >
        {buttonLabel}
      </Button>
    </Flex>
  )
}
